export const CALLS_FETCH_MANY_REQUEST = 'CALLS_FETCH_MANY_REQUEST'
export const CALLS_FETCH_MANY_SUCCESS = 'CALLS_FETCH_MANY_SUCCESS'
export const CALLS_FETCH_MANY_FAILURE = 'CALLS_FETCH_MANY_FAILURE'

export const CALLS_FETCH_REQUEST = 'CALLS_FETCH_REQUEST'
export const CALLS_FETCH_SUCCESS = 'CALLS_FETCH_SUCCESS'
export const CALLS_FETCH_FAILURE = 'CALLS_FETCH_FAILURE'
